import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { HERO_IMAGE } from "./data/images";
function addLink(rel: string, href: string, extra?: Partial<HTMLLinkElement>) {
  const link = document.createElement("link");
  link.rel = rel;
  link.href = href;
  Object.assign(link, extra ?? {});
  document.head.appendChild(link);
}

// Warm up the font + CDN connections and start the hero image before React mounts.
addLink("preconnect", "https://fonts.googleapis.com");
addLink("preconnect", "https://fonts.gstatic.com", {
  crossOrigin: "anonymous"
});
addLink("preconnect", "https://cdn.magicpatterns.com");
addLink("preload", HERO_IMAGE, {
  as: "image",
  fetchPriority: "high"
} as Partial<HTMLLinkElement>);
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-238" data-mp="2tws6hs6wx80w" />);
}